import { axiosInstance } from '@/axios';
import type { FeedItemType } from '@/types';

import { formatResult } from './formatResult';

export const fetchAndFormatDocument = async ({
  access_key,
  category,
  deeplink,
  public_access_key,
  source,
}: FetchAndFormatDocType) => {
  const { data } = await axiosInstance.get<{ results: FeedItemType[] }>(
    `/doc/${source}`,
    {
      params: {
        deeplink,
        access_key,
        public_access_key,
      },
    }
  );

  if (data.results && data.results.length > 0) {
    const fromQuery = formatResult(data.results[0], category, 'doc');

    return fromQuery;
  }

  return null;
};

type Common = {
  category: string;
  deeplink: string;
  source: string;
};

type FetchAndFormatDocType =
  | (Common & { access_key: string; public_access_key?: string })
  | (Common & { access_key?: string; public_access_key: string });
